import { DocumentTypeEnum } from "../data/models/applications/CreditApplication";
import { onlyDigits } from "./StringTool";

export function validateDocumentByType(
  type?: DocumentTypeEnum,
  value?: string
): string | undefined {
  if (!type || type.trim() === "") return "Selecciona un tipo de documento";
  if (!value || value.trim() === "") return "Ingresa tu número de documento";
  const digits = onlyDigits(value);
  if (type === "CC" || type === "TI") {
    if (digits.length < 6 || digits.length > 12) return "Documento inválido";
  } else if (type === "CE") {
    if (digits.length < 5 || digits.length > 12) return "Documento inválido";
  } else if (type === "NIT") {
    if (digits.length < 8 || digits.length > 15) return "NIT inválido";
  } else if (type === "PAS") {
    if (value.length < 5 || value.length > 15) return "Pasaporte inválido";
  } else if (type === "PPT" || type === "PASAPORTE") {
    if (value.length < 5 || value.length > 20) return "Documento inválido";
  } else {
    return "Tipo de documento no reconocido";
  }
  return undefined;
}
